export class AwsRdsSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceClass",
            "baseName": "instanceClass",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRdsSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
